import React from "react";
import { Grid } from "@material-ui/core";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { Controller } from "react-hook-form";
import { EventNotification } from "../../domain/EventNotification";
import { SectionProps } from "./SectionProps";
import { fieldLabels } from "./fieldLabels";

export const ActionsTaken: React.FC<SectionProps<EventNotification>> = ({
  control,
  errors,
  disabled,
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="actionsTakenToIdentifyCauseAndEffect"
          as={
            <TextField
              label={fieldLabels["actionsTakenToIdentifyCauseAndEffect"]}
              readOnly={disabled}
              multiline
              data-test="actions-taken-cause-effect"
            />
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="actionsTakenToMitigateAdverseEffect"
          as={
            <TextField
              label={fieldLabels["actionsTakenToMitigateAdverseEffect"]}
              readOnly={disabled}
              multiline
              data-test="action-taken-adverse-effect"
            />
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="actionsTakenToPreventReoccurrencce"
          as={
            <TextField
              label={fieldLabels["actionsTakenToPreventReoccurrencce"]}
              readOnly={disabled}
              multiline
              data-test="action-taken-reoccurence"
            />
          }
        />
      </Grid>
    </Grid>
  );
};
